import { useContext, useState } from 'react';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import EditIcon from '@mui/icons-material/Edit';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import PartyNumberingForm from './PartyNumberingForm';

import { AuthContext } from '../../Context/AuthContext';
import { IconButton, Stack, Typography } from '@mui/material';
export default function PartyCardAction({ item, setRefetch }) {

  // Change Language
  const { t, setAlert } = useContext(AuthContext);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [openNumbering, setOpenNumbering] = useState(false);
  const handleOpenNumbering = () => {
    setOpenNumbering(true);
    handleClose();
  }
  const handleCloseNumbering = () => setOpenNumbering(false);

  return (
    <div>
      <IconButton
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        <MoreVertIcon className="icon" />
      </IconButton>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            'aria-labelledby': 'basic-button',
          },
        }}

        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >

        <MenuItem onClick={handleOpenNumbering}>
          <Stack direction="row" spacing={1.5}>
            <EditIcon sx={{ color: "orange" }} />
            <Typography sx={{ color: "gray", fontSize: 15 }}>
              {t("thead_numbering")}
            </Typography>
          </Stack>
        </MenuItem>
      </Menu>


      <PartyNumberingForm
        open={openNumbering}
        handleClose={handleCloseNumbering}
        editData={item}
        setRefetch={setRefetch}
      />
    </div>
  );
}
